export default __webpack_public_path__ + "static/media/bg.65a24ce8.png";